import styled from "@emotion/styled";

const StyledButton = styled.button`
  display: inline-block;
  font-weight: 400;
  color: ;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: xtransparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;  
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.75rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;
  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: none !important;
`;

const Button = ({
    children,
    ...props
}: React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
>) => <StyledButton {...props}>{children}</StyledButton>;

export default Button;
